'use client';

import { useEffect, useMemo } from 'react';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

type DropzonePreviewProps = {
  file: File;
  onRemove: () => void;
  disabled?: boolean;
};

const DropzonePreview = ({ file, onRemove, disabled }: DropzonePreviewProps) => {
  const previewUrl = useMemo(() => URL.createObjectURL(file), [file]);

  useEffect(() => {
    return () => URL.revokeObjectURL(previewUrl);
  }, [previewUrl]);

  return (
    <Box sx={{ position: 'relative', width: 100, height: 100 }} onClick={(e) => e.stopPropagation()}>
      <Box
        component="img"
        src={previewUrl}
        alt={file.name}
        sx={{
          width: 100,
          height: 100,
          objectFit: 'cover',
          borderRadius: 1,
        }}
      />
      <IconButton
        size="small"
        onClick={onRemove}
        disabled={disabled}
        sx={{
          position: 'absolute',
          top: -8,
          right: -8,
          bgcolor: 'background.paper',
          boxShadow: 1,
          '&:hover': { bgcolor: 'grey.200' },
          padding: '2px',
        }}
      >
        <CloseIcon sx={{ fontSize: 16 }} />
      </IconButton>
    </Box>
  );
};

export default DropzonePreview;
